import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllFrontlineOrdersContent} from './AllFrontlineOrdersContent';
import reportPayload from './reportPayload';

interface AllFrontlineOrdersReportProps {
  loadingData: {
    total?: number;
  };
  tt: (key: string, defaultValue?: string) => string;
  showRecordPopover: (...args: any[]) => void;
}

export const AllFrontlineOrdersReport: React.FC<
  AllFrontlineOrdersReportProps
> = ({
  loadingData = {},
  tt = (_key, defaultValue) => defaultValue || '',
  showRecordPopover = noop,
  ...props
}) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Frontline Orders')}
      description={tt(
        'description',
        'All orders from your Frontline Clients & Coaches.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllFrontlineOrdersContent}
      {...props}
    />
  );
};

export default withHOC(
  withTranslation('report.allFrontlineOrders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllFrontlineOrdersReport);
